import { siteName, siteTagline } from '@/mocks/home';

const footerLinks = [
  {
    title: '影视分类',
    links: [
      { label: '热门电影', href: '#index' },
      { label: '高分剧集', href: '#index' },
      { label: '动漫番剧', href: '#index' },
      { label: '纪录片', href: '#index' },
      { label: '综艺节目', href: '#index' },
    ],
  },
  {
    title: '快速入口',
    links: [
      { label: '热度榜单', href: '#ranking' },
      { label: '最新动态', href: '#updates' },
      { label: '精选推荐', href: '#cards' },
      { label: '用户热评', href: '#comments' },
      { label: '常见问题', href: '#faq' },
    ],
  },
  {
    title: '合作伙伴',
    links: [],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', href: '#about' },
      { label: '联系我们', href: '#contact' },
      { label: '移动端', href: '#app' },
    ],
  },
];

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 pt-12 md:pt-16 pb-6 md:pb-8 px-4 md:px-6 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <span className="text-2xl font-black whitespace-nowrap" style={{ fontFamily: "'ZCOOL KuaiLe', cursive" }}>
              <span className="text-primary-500">萝卜</span>
              <span className="text-foreground-900">影视</span>
            </span>
            <p className="text-sm text-foreground-500 mt-3 leading-relaxed max-w-xs">
              {siteTagline}。汇聚海量高清影视资源，每日更新热门电影和电视剧，免费在线观看，全程流畅不缓冲。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-bold text-foreground-900 mb-4">{group.title}</h4>
              {group.links.length > 0 ? (
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => handleClick(e, link.href)}
                        className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-foreground-400">暂未开放</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400 text-center sm:text-left">
            &copy; {new Date().getFullYear()} {siteName} 版权所有 | 免费电影在线观看 | 免费追剧平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
              回到顶部
              <i className="ri-arrow-up-line ml-1"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}